<div
    class="container"
    style="margin-top: 50px"
>
    <img
        alt="WuDo"
        id="main-logo"
        style="margin-top: 30px; margin-bottom: 30px"
    />

    <h4>{{ 'contactUs.title' | translate }}</h4>
    <h6>
        {{ 'contactUs.supportMail' | translate }}
        <a href="mailto:{{ 'home.pages.help.supportMail' | translate }}">{{
            'home.pages.help.supportMail' | translate
        }}</a>
    </h6>

    <p>
        {{ 'contactUs.body' | translate }}
    </p>

    <h6>
        {{ 'contactUs.dataMail' | translate }}
        <a href="mailto:{{ emails.rgpd }}">{{ emails.rgpd }}</a>
    </h6>
</div>
